/* */ 
'use strict';
var jsonParser = require('./parsers/json'),
    yamlParser = require('./parsers/yaml'),
    textParser = require('./parsers/text'),
    binaryParser = require('./parsers/binary'),
    fileResolver = require('./resolvers/file'),
    httpResolver = require('./resolvers/http'),
    zschemaValidator = require('./validators/z-schema');
module.exports = $RefParserOptions;
function $RefParserOptions(options) {
  merge(this, $RefParserOptions.defaults);
  merge(this, options);
}
$RefParserOptions.defaults = {
  parse: {
    json: jsonParser,
    yaml: yamlParser,
    text: textParser,
    binary: binaryParser
  },
  resolve: {
    file: fileResolver,
    http: httpResolver,
    external: true
  },
  dereference: {circular: true},
  validate: {zschema: zschemaValidator}
};
function merge(target, source) {
  if (isMergeable(source)) {
    var keys = Object.keys(source);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var sourceSetting = source[key];
      var targetSetting = target[key];
      if (isMergeable(sourceSetting)) {
        target[key] = merge(targetSetting || {}, sourceSetting);
      } else if (sourceSetting !== undefined) {
        target[key] = sourceSetting;
      }
    }
  }
  return target;
}
function isMergeable(val) {
  return val && (typeof val === 'object') && !Array.isArray(val) && !(val instanceof RegExp) && !(val instanceof Date);
}
